import useLenis from "@/hooks/useLenis";
import { Navbar } from "@/components/mrs/Navbar";
import { Hero } from "@/components/mrs/Hero";
import { Manifesto } from "@/components/mrs/Manifesto";
import { Services } from "@/components/mrs/Services";
import { EditorialMarquee } from "@/components/mrs/EditorialMarquee";
import { Approach } from "@/components/mrs/Approach";
import { WhyUs } from "@/components/mrs/WhyUs";
import { Process } from "@/components/mrs/Process";
import { Pricing } from "@/components/mrs/Pricing";
import { Gallery } from "@/components/mrs/Gallery";
import { Contact } from "@/components/mrs/Contact";

export default function LandingPage() {
  useLenis();

  return (
    <div className="grain" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Manifesto />
        <Services />
        <EditorialMarquee />
        <Approach />
        <WhyUs />
        <Process />
        <Pricing />
        <Gallery />
        <Contact />
      </main>
    </div>
  );
}
